/* Polsk katalog for locale-payroll-runs-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'pay.salaryTypeSaved': 'Rodzaj wynagrodzenia zapisany.',
  'pay.salaryTypeSaveFailed': 'Nie udało się zapisać rodzaju wynagrodzenia.',
  'pay.fixedLineSaved': 'Stała linia płacowa zapisana.',
  'pay.fixedLineSaveFailed': 'Nie udało się zapisać stałej linii płacowej.',
  'pay.fillNameAndAccountNumber': 'Wpisz nazwę i numer konta.',
  'pay.accountAdded': 'Konto dodane.',
  'pay.addAccountFailed': 'Nie udało się dodać konta.',
  'pay.calculationCodeNotSupported': 'Ten kod obliczania składki pracodawcy nie jest jeszcze obsługiwany. Wybierz „Branże ogólne”.',
  'pay.payrollSettingsSaved': 'Ustawienia płac zapisane.',
  'pay.payrollSettingsSavedWithRecalc': 'Ustawienia płac zapisane. Przeliczone otwarte szkice list płac: {count}.',
  'pay.payrollSettingsSaveFailed': 'Nie udało się zapisać ustawień płac.',
  'pay.markedManualSubmission': 'Oznaczono jako złożenie ręczne.',
  'pay.ameldingSentToAltinn': 'A-melding wysłano do Altinn.',
  'pay.payslipsCreatedAndPosted': 'Utworzono paski wynagrodzenia i zaksięgowano płace. Paski można wysłać później.',
  'pay.payrollRunEditableAgain': 'Wypłatę wynagrodzeń można ponownie edytować.',
  'pay.accountingAnnulled': 'Księgowanie zostało anulowane.',
  'pay.payrollRunAnnulled': 'Wypłata wynagrodzeń anulowana.',
  'pay.payoutRegistered': 'Wypłata zarejestrowana.',
  'pay.confirmAnnulPayment': 'Anulować tę płatność? Księgowanie zostanie odwrócone, ponieważ płatność nie będzie już uwzględniana.',
  'pay.hideDeletedPayrollRuns': 'Ukryj usunięte wypłaty wynagrodzeń',
  'pay.showDeletedPayrollRuns': 'Pokaż usunięte wypłaty wynagrodzeń ({count})',
  'pay.removePermanently': 'Usuń trwale',
  'pay.removeDeletedPayrollRunPermanently': 'Usuń trwale usuniętą wypłatę wynagrodzeń',
  'pay.confirmRemoveDeletedPayrollRunTitle': 'Usunąć usuniętą wypłatę wynagrodzeń?',
  'pay.confirmRemoveDeletedPayrollRunMessage': 'To trwale usunie szkic za {period}. Tutaj można usunąć tylko płace, które nigdy nie zostały zatwierdzone, wysłane ani zaksięgowane.',
  'pay.editPaymentTitle': 'Edytuj płatność',
  'pay.registerPaymentTitle': 'Zarejestruj płatność',
  'pay.savingEllipsis': 'Zapisywanie...',
  'pay.savePaymentAction': 'Zapisz płatność',
  'pay.editSalaryTypeTitle': 'Edytuj rodzaj wynagrodzenia',
  'pay.newFixedLineTitle': 'Nowa stała linia płacowa',
  'pay.editFixedLineTitle': 'Edytuj stałą linię płacową',
  'pay.operatingAccount': 'Konto operacyjne',
  'pay.newWithholdingAccountTitle': 'Nowe konto potrąceń podatkowych',
  'pay.newPayrollAccountTitle': 'Nowe konto płacowe',
  'pay.addAccountAction': 'Dodaj konto',
  'pay.totalPay': 'Łączne wynagrodzenie',
  'pay.taxDeduction': 'Potrącenie podatku',
  'pay.voucher': 'Dokument',
  'pay.basis': 'Podstawa',
  'pay.payrollRuns': 'Listy płac',
  'pay.agaOfHolidayPayFull': 'Składka pracodawcy od dodatku urlopowego',
  'pay.deadline': 'Termin',
  'pay.paidAmount': 'Zapłacono',
  'pay.remaining': 'Pozostało',
  'pay.provider': 'Dostawca',
  'pay.orgNumber': 'Nr org.',
  'pay.earnedAtStandardRate': 'Naliczone (10,2 %)',
  'pay.ameldingRegistered': 'A-melding zarejestrowana',
  'pay.noSubmissions': 'Brak zgłoszeń',
  'pay.posted': 'Zaksięgowano',
  'pay.notPosted': 'Niezaksięgowane',
  'pay.payslipsNotGenerated': 'Paski wynagrodzenia nie zostały wygenerowane.',
  'pay.employmentSetOnEmployeePage': 'Stosunek pracy ustawia się na stronie pracownika',
  'pay.rulesFromSalaryType': 'Zasady z rodzaju wynagrodzenia',
  'pay.useStandardRules': 'Użyj zasad standardowych',
  'pay.advancedSettings': 'Ustawienia zaawansowane',
  'pay.overrideCanChangeCalculation': 'Nadpisanie może zmienić podatek, składkę pracodawcy, dodatek urlopowy, OTP i księgowanie dla tej linii.',
  'pay.removeFromFixedLines': 'Usuń ze stałych linii płacowych',
  'pay.makeThisAFixedLine': 'Ustaw jako stałą linię płacową',
  'pay.withholdingExceedsCashPayWarning': 'Zaliczka na podatek jest wyższa niż wynagrodzenie gotówkowe i zwroty. Dodaj wynagrodzenie gotówkowe lub zmniejsz potrącenie, zanim lista płac będzie mogła zostać zatwierdzona.',
  'pay.attachDocumentationHint': 'Dołącz dokumentację do wypłaty wynagrodzeń, np. karty czasu pracy lub ręczne rozliczenia podróży.',
  'pay.upload': 'Prześlij',
  'pay.step1AltinnHelp': 'Gdy wszystkie linie są uwzględnione, następnym krokiem jest zgłoszenie wypłaty wynagrodzeń. Integracja z Altinn zostanie podłączona później, więc na razie zgłoszenie można oznaczyć jako złożenie ręczne.',
  'pay.step3PayslipsHelp': 'Gdy wypłata wynagrodzeń zostanie zgłoszona i zatwierdzona, tworzone są paski wynagrodzenia, a płace są księgowane.',
  'pay.step4PaymentHelp': 'Zarejestruj i zaksięguj wypłatę wynagrodzeń pracownikom oraz zaliczki na podatek do Skatteetaten.',
  'pay.payrollRunCompletesWhenPaid': 'Wypłata wynagrodzeń zostanie zakończona po zarejestrowaniu płatności.',
  'pay.productionSupportedProfile': 'Profil obsługiwany produkcyjnie: płace norweskie, okres miesięczny, Branże ogólne i karty procentowe. Karty tabelaryczne, specjalne kody składki pracodawcy i elektroniczne złożenie bez potwierdzenia są zablokowane.',
  'pay.searchMunicipalityOrNumber': 'Szukaj gminy lub numeru',
  'pay.notSupportedYet': 'jeszcze nieobsługiwane',
  'pay.chooseGeneralIndustriesWarning': 'Wybierz „Branże ogólne”, zanim zapiszesz ustawienia. Wcześniej wybrany kod obliczania nie jest zaimplementowany.',
  'pay.searchProvider': 'Szukaj dostawcy',
  'pay.month.may': 'Maj',
  'pay.payTypeNotFixedLine': 'Tego rodzaju wynagrodzenia nie można użyć jako stałej linii płacowej.',
  'pay.calculationCodeUnsupportedShort': 'Ten kod obliczania składki pracodawcy nie jest jeszcze obsługiwany.',
  'pay.overtimePay': 'Nadgodziny',
  'pay.mileageAllowance': 'Kilometrówka',
  'pay.driveFallback': 'Przejazd',
  'pay.taxableMileagePortion': 'Część podlegająca opodatkowaniu',
  'pay.expenseCategoryOther': 'Inne',
  'pay.overnightStayFallback': 'Nocleg',
  'pay.hotelFallback': 'Hotel',
  'pay.mileagePayoutFallback': 'Zwrot za przejazd',
  'pay.ownCar': 'Własny samochód',
  'pay.travelPurposeFallback': 'Podróż',
  'pay.taxTermWithholdingLabel': 'Zaliczka na podatek {{date}}',
  'pay.taxTermAgaLabel': 'Okres {{term}}',
  'pay.payrollRunNotEditableForNewLines': 'Do zatwierdzonej listy płac nie można dodać nowych linii płacowych.',
  'pay.payTypeNotManualEntry': 'Tego rodzaju wynagrodzenia nie można dodać ręcznie.',
  'pay.receiptInboxFallbackName': 'Dokument ze skrzynki odbiorczej',
  'pay.approvedButPayslipsFailed': 'Płace zostały zaksięgowane, ale paski wynagrodzenia nie zostały wysłane: {{error}}',
  'pay.recon.runLabelPeriod': 'Płace {{period}}',
  'pay.recon.runLabelRun': 'Lista płac {{date}}',
  'pay.recon.notPaid': 'Niewypłacone',
  'pay.recon.paidAfterPeriod': 'Wypłacone po dacie okresu',
  'pay.recon.flag.negativ_netto': 'Ujemne wynagrodzenie netto',
  'pay.recon.flag.mangler_skattekort': 'Brak karty podatkowej',
  'pay.recon.flag.sluttet_ansatt': 'Wypłata dla byłego pracownika',
  'pay.recon.flag.naturalytelse': 'Świadczenie rzeczowe do sprawdzenia',
  'pay.recon.flag.uvanlig_endring': 'Nietypowa zmiana wynagrodzenia',
  'pay.recon.flag.mangler_amelding': 'Brak w A-melding',
  'pay.recon.flag.mulig_duplikat': 'Możliwa podwójna wypłata',
  'pay.recon.flag.ikke_utbetalt': 'Niewypłacone',
  'pay.recon.unknownEmployee': 'Nieznany pracownik',
  'pay.recon.employmentTypeFixed': 'Stałe',
  'pay.recon.reported': 'Zgłoszone',
  'pay.recon.notReported': 'Niezgłoszone',
  'pay.recon.afterPeriodDate': 'Po dacie okresu',
  'pay.recon.role.forskuddstrekk': 'Zaliczka na podatek w okresie',
  'pay.recon.role.aga': 'Obliczona składka pracodawcy od wynagrodzeń',
  'pay.recon.role.aga_feriepenger': 'Obliczona składka pracodawcy od dodatku urlopowego',
  'pay.recon.role.feriepenger': 'Zobowiązanie z tytułu dodatku urlopowego według systemu płacowego',
  'pay.recon.role.skyldig_lonn': 'Wynagrodzenie netto i potrącenia z systemu płacowego',
  'pay.recon.role.pensjon': 'Składka emerytalna z systemu płacowego',
  'pay.recon.row.brutto': 'Wynagrodzenie brutto',
  'pay.recon.row.naturalytelser': 'Opodatkowane świadczenia rzeczowe',
  'pay.recon.row.trekkpliktige': 'Świadczenia podlegające potrąceniu',
  'pay.recon.row.godtgjorelser': 'Zwroty kosztów',
  'pay.recon.row.aga_grunnlag': 'Podstawa składki pracodawcy',
  'pay.recon.row.aga': 'Obliczona składka pracodawcy',
  'pay.recon.row.netto': 'Wynagrodzenie netto',
  'pay.recon.row.andre_trekk': 'Inne potrącenia',
  'pay.recon.row.feriepenger': 'Naliczony dodatek urlopowy',
  'pay.recon.row.pensjon': 'Składka emerytalna',
  'pay.recon.source.payrollSystem': 'System płacowy',
  'pay.recon.source.bankPayouts': 'Wypłaty bankowe',
  'pay.recon.source.pensionBasis': 'Podstawa emerytalna',
  'pay.recon.source.payrollSystemDetailSingular': 'Zaksięgowane listy płac w okresie: {{count}}',
  'pay.recon.source.payrollSystemDetailPlural': 'Zaksięgowane listy płac w okresie: {{count}}',
  'pay.recon.source.payrollSystemDetailEmpty': 'Brak zaksięgowanych list płac w okresie',
  'pay.recon.source.ledgerDetail': 'Księgowania na kontach płacowych: {{count}}',
  'pay.recon.source.ledgerDetailEmpty': 'Brak księgowań na kontach dodanych do obszaru płac',
  'pay.recon.source.ameldingDetailNone': 'Brak list płac do zgłoszenia',
  'pay.recon.source.ameldingDetailAllReported': '{{reported}} z {{total}} list płac zarejestrowano jako zgłoszone',
  'pay.recon.source.ameldingDetailMissing': '{{missing}} z {{total}} list płac nie zarejestrowano jako zgłoszone',
  'pay.recon.source.bankDetailNone': 'Brak list płac do zapłaty',
  'pay.recon.source.bankDetailPaid': '{{paid}} z {{total}} list płac zarejestrowano jako wypłacone',
  'pay.recon.source.pensionDetailPresent': 'Składka emerytalna obliczona przez system płacowy',
  'pay.recon.source.pensionDetailNone': 'Brak składki emerytalnej w okresie',
  'pay.recon.check.bokfort': 'Wszystkie listy płac są zaksięgowane',
  'pay.recon.check.hovedbok': 'System płacowy zgadza się z księgą główną',
  'pay.recon.check.kontrollkontoer': 'Konta kontrolne zgadzają się z podstawą',
  'pay.recon.check.bank': 'Wynagrodzenie netto zostało wypłacone',
  'pay.recon.check.amelding': 'A-melding została zarejestrowana jako złożona',
  'pay.recon.check.skattekort': 'Wszyscy pracownicy mają ważną kartę podatkową',
  'pay.recon.check.negativ': 'Brak ujemnych kwot netto',
  'pay.recon.check.duplikat': 'Możliwe podwójne wypłaty zostały zidentyfikowane',
  'pay.recon.check.uvanlig': 'Nietypowe zmiany wynagrodzeń zostały zidentyfikowane',
  'pay.recon.check.sluttet': 'Wypłaty dla byłych pracowników zostały zidentyfikowane',
  'pay.recon.check.naturalytelse': 'Świadczenia rzeczowe zostały przeanalizowane',
  'pay.recon.check.feriepenger': 'Zobowiązanie z tytułu dodatku urlopowego jest uzgodnione',
  'pay.recon.check.termin': 'Zaliczka na podatek i składka pracodawcy zostały rozliczone',
  'pay.creatingRun': 'Tworzenie…',
  'pay.pensionPremiumAmount': 'Faktyczna składka emerytalna',
  'pay.pensionBankAmount': 'Zapłacono z banku',
  'pay.pensionFeeAmount': 'Osobna opłata (brutto)',
  'pay.pensionFeeVat': 'VAT od opłaty',
  'pay.pensionFeeAccount': 'Konto kosztowe opłaty',
  'pay.pensionOverpaymentNotice': 'Różnica zostanie zaksięgowana jako zaliczka dla dostawcy emerytalnego na koncie 1570.',
  'pay.createLaterCorrection': 'Utwórz korektę w późniejszym okresie',
  'pay.createCorrection': 'Utwórz korektę',
  'pay.laterCorrectionHelp': 'Pierwotne naliczenie zostaje zachowane. Po zatwierdzeniu korekty w nowym okresie księgowana jest tylko różnica.',
  'pay.correctionCreated': 'Naliczenie korygujące zostało utworzone jako szkic.',
  'pay.typeStandard': 'Standardowy',
  'pay.typeCustom': 'Własny',
  'pay.statusInactive': 'Nieaktywny',
  'pay.ruleTag.aga': 'AGA',
  'pay.ruleTag.tax': 'Podatek',
  'pay.ruleTag.holiday': 'Urlop.',
  'pay.ruleTag.pension': 'OTP',
  'pay.ruleTitle.aga': 'Podlega składce pracodawcy',
  'pay.ruleTitle.tax': 'Podlega zaliczce na podatek',
  'pay.ruleTitle.holiday': 'Podstawa dodatku urlopowego',
  'pay.ruleTitle.pension': 'Podstawa emerytalna',
  'pay.stdType.monthly-salary': 'Wynagrodzenie stałe',
  'pay.stdType.hourly': 'Stawka godzinowa - bez nadgodzin',
  'pay.stdType.overtime-hourly': 'Stawka godzinowa - nadgodziny',
  'pay.stdType.commission-pay': 'Honorarium, akord, wynagrodzenie procentowe lub prowizyjne',
  'pay.stdType.bonus-holiday-pay': 'Premia, wliczana do dodatku urlopowego',
  'pay.stdType.bonus-no-holiday-pay': 'Premia, niewliczana do dodatku urlopowego',
  'pay.stdType.board-fee': 'Wynagrodzenie członka zarządu',
  'pay.stdType.company-car': 'Samochód służbowy',
  'pay.stdType.other-benefits': 'Inne świadczenia',
  'pay.stdType.taxable-insurance': 'Ubezpieczenia, część opodatkowana',
  'pay.stdType.car-km-allowance': 'Kilometrówka',
  'pay.stdType.car-km-allowance-taxable': 'Kilometrówka, część podlegająca zaliczce',
  'pay.stdType.holiday-pay-current': 'Dodatek urlopowy nabyty w bieżącym roku',
  'pay.stdType.holiday-pay-previous': 'Dodatek urlopowy nabyty w poprzednich latach',
  'pay.stdType.pension-premium': 'Składka emerytalna OTP',
  'pay.stdType.canteen-deduction': 'Potrącenie za stołówkę',
  'pay.stdType.holiday-deduction': 'Potrącenie z wynagrodzenia za urlop',
  'pay.stdType.extra-tax-deduction': 'Dodatkowa zaliczka na podatek',
  'pay.stdType.employee-expense-settlement': 'Zwrot kosztów podróży',
  'pay.stdType.overnight-diet-hotel': 'Dieta z noclegiem',
});
